<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Evaluasi Pelaksanaan">
            <common-training-header/>
        </a-page-header>
        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :rowClassName="(r) => r.is_heading ? 'row-heading' : null"
                bordered
                >

                <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                    <div slot-scope="record" v-show="! record.is_heading">
                        {{ record.inspirator }}
                    </div>
                </a-table-column>

                <a-table-column-group>
                    <span slot="title">Evaluasi Pelaksanaan</span>

                    <a-table-column key="ev_inspirator" title="Inspirator" className="align-center text-small text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <a-button type="link" size="small" @click="evaluate('inspirator', record.materi_id, true)" v-if="record.ev_inspirator">
                                <strong> {{ record.ev_inspirator }}</strong>
                            </a-button>

                            <a-button type="link" icon="plus" size="small" @click="evaluate('inspirator', record.materi_id, false)" v-else :disabled="! record.session_timeout">
                                <div class="fontSmall"> Tambah</div>
                            </a-button>
                        </template>
                    </a-table-column>

                    <a-table-column key="ev_materi" title="Materi" className="align-center text-small text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <a-button type="link" size="small" @click="evaluate('material', record.materi_id, true)" v-if="record.ev_materi">
                                <strong> {{ record.ev_materi }}</strong>
                            </a-button>

                            <a-button type="link" icon="plus" size="small" @click="evaluate('material', record.materi_id, false)" v-else :disabled="! record.session_timeout">
                                <div class="fontSmall"> Tambah</div>
                            </a-button>
                        </template>
                    </a-table-column>

                    <a-table-column key="ev_program" title="Program" className="align-center text-small text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <a-button type="link" size="small" @click="evaluate('program', record.materi_id, true)" v-if="record.ev_program">
                                <strong> {{ record.ev_program }}</strong>
                            </a-button>

                            <a-button type="link" icon="plus" size="small" @click="evaluate('program', record.materi_id, false)" v-else :disabled="! record.session_timeout">
                                <div class="fontSmall"> Tambah</div>
                            </a-button>
                        </template>
                    </a-table-column>

                    <a-table-column key="ev_penyelenggaraan" title="Penyelenggaraan" className="align-center text-small text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <a-button type="link" size="small" @click="evaluate('event', record.materi_id, true)" v-if="record.ev_penyelenggaraan">
                                <strong> {{ record.ev_penyelenggaraan }}</strong>
                            </a-button>

                            <a-button type="link" icon="plus" size="small" @click="evaluate('event', record.materi_id, false)" v-else :disabled="! record.session_timeout">
                                <div class="fontSmall"> Tambah</div>
                            </a-button>
                        </template>
                    </a-table-column>

                    <a-table-column key="ev_akomodasi" title="Akomodasi" className="align-center text-small text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <a-button type="link" size="small" @click="evaluate('acomodation', record.materi_id, true)" v-if="record.ev_akomodasi">
                                <strong> {{ record.ev_akomodasi }}</strong>
                            </a-button>

                            <a-button type="link" icon="plus" size="small" @click="evaluate('acomodation', record.materi_id, false)" v-else :disabled="! record.session_timeout">
                                <div class="fontSmall"> Tambah</div>
                            </a-button>
                        </template>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column key="result" title="Hasil" className="align-center text-small text-center">
                    <div slot-scope="record" v-show="! record.is_heading">
                        <h3>{{ record.result ? record.result.toFixed(2) : '' }}</h3>
                    </div>
                </a-table-column>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment'

const materi = {
    id: 1,
    name: null,
    inspirator: null,
    ev_inspirator: null,
    ev_materi: null,
    ev_program: null,
    ev_penyelenggaraan: null,
    ev_akomodasi: null,
    result: null,
    materi_id: null,
    is_heading: false,
    session_timeout: false,
    session_time_end: null,
}

export default {
    created() {
        this.getItems()
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            items: {},
            data: {
                categories: []
            }
        };
    },
    computed: {
        tableData() {
            let collection = []
            let num = 1

            if(this.items.length > 0){
                this.items.forEach(item => {
                    if(item.type === 'category'){
                        collection.push(Object.assign(Object.create(materi), {
                            id: num++,
                            name: item.name,
                            inspirator: null,
                            ev_inspirator: null,
                            ev_materi: null,
                            ev_program: null,
                            ev_penyelenggaraan: null,
                            ev_akomodasi: null,
                            result: null,
                            materi_id: null,
                            is_heading: true,
                            session_timeout: false,
                            session_time_end: null,
                        }))

                        item.materials.forEach(function (item, index) {
                            let ev_inspirator = null
                            let ev_materi = null
                            let ev_program = null
                            let ev_penyelenggaraan = null
                            let ev_akomodasi = null

                            if(item.attendant_training_evaluations.length > 0){
                                item.attendant_training_evaluations.forEach(item => {
                                    switch (item.type) {
                                        case "inspirator":
                                            ev_inspirator = item.score
                                            break;
                                        case "material":
                                            ev_materi = item.score
                                            break;
                                        case "program":
                                            ev_program = item.score
                                            break;
                                        case "event":
                                            ev_penyelenggaraan = item.score
                                            break;
                                        case "acomodation":
                                            ev_akomodasi = item.score
                                            break;
                                        default:
                                            break;
                                    }
                                })
                            }

                            collection.push(Object.assign(Object.create(materi), {
                                id: num++,
                                name: item.name,
                                inspirator: item.sessions[0].inspirator.name,
                                ev_inspirator: ev_inspirator,
                                ev_materi: ev_materi,
                                ev_program: ev_program,
                                ev_penyelenggaraan: ev_penyelenggaraan,
                                ev_akomodasi: ev_akomodasi,
                                result: item.material_score,
                                materi_id: item.id,
                                is_heading: false,
                                session_timeout: moment().locale('id').format() >= item.sessions[0].session_time_end,
                                session_time_end: item.sessions[0].session_time_end,
                            }))
                        })
                    }
                })
            }

            return collection
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri("api.training.evaluation"), {
                    params: {
                        xhr: true
                    }
                })
                .then((response) => {
                    this.items = response.data.materials.categories
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        evaluate(type, materialId, edited){
            let params = {
                type: type,
                edt: edited,
                material_id: materialId
            }

            window.location.href = this.routeUri('admin.classical.attendant.evaluation.show', {
                material: materialId
            }) + '?' + this.$qs.stringify(params)
        },
    }
};
</script>

<style scoped>
div.fontSmall {
    font-size: 12px;
}
</style>
